import './public-path.js'
import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import singleSpaCanopy from 'single-spa-canopy';

export { connectAccountModal } from './settings/account-wizard/externally-exported-connect-account.component.js';
export { sendBulkEmail } from './bulk-email/send-bulk-email.js';
export { reauthenticationDrawerParcel } from './reauthentication/reauthentication-drawer.component.js';
export { sanitizeRichTextHtml } from 'src/rich-text/bandicoot-html-sanitizer';

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  loadRootComponent: () => import(/* webpackChunkName: "communications-app" */'./root.component.js').then(md => md.default),
  domElementGetter,
});

const toggles = [
  'email_signature_images',
  'ft_email_sharing',
  'toggle_email_labels',
  'toggle_file_attachments',
];

const canopyLifecycles = singleSpaCanopy({
  domElementGetter,
  featureToggles: toggles
});

export const bootstrap = [
  canopyLifecycles.bootstrap,
  reactLifecycles.bootstrap,
];

export const mount = [
  reactLifecycles.mount,
  canopyLifecycles.mount,
];

export const unmount = [
  reactLifecycles.unmount,
  canopyLifecycles.unmount,
];

export const unload = [
  canopyLifecycles.unload,
];

function domElementGetter() {
  let el = document.getElementById('communications-ui');
  if (!el) {
    el = document.createElement('div');
    el.setAttribute('id', 'communications-ui');
    document.body.insertBefore(el, document.body.childNodes[0]);
  }
  return el;
}

function fetchToggles() {
  if (toggles.length > 0) {
    return SystemJS.import("feature-toggles!sofe").then(mod => mod.fetchFeatureToggles.apply(null, toggles))
  } else {
    return Promise.resolve()
  }
}

export function getComposeEmailOverlay() {
  return fetchToggles()
    .then(() => import(/*webpackChunkName: "compose-email-overlay" */ './exports/compose-email.component.js')
      .then(mod => mod))
}

export async function getEmailInfo() {
  await fetchToggles()
  return await import(/*webpackChunkName: "email-info" */ './exports/email-info.component.js')
}

export async function getViewEmailThread() {
  await fetchToggles()
  return await import(/*webpackChunkName: "view-email-thread" */ './exports/view-email-thread/view-email-thread.component.js')
}
